import { Navbar, Button, Image } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

export const NavigationBar = () => {
    const { user, logout, loading } = useAuth();

    return (
        <>
            <Navbar bg="primary" variant="dark" className="navbarStyle navbar-campus px-3">
                <a className="navbar-brand" href="/">
                    ACADEMY CAMPUS
                </a>
                <div className="collapse navbar-collapse justify-content-end gap-3 align-items-center">
                    {user ? (
                        <>
                            {user.photoURL && (
                                <Image
                                    src={user.photoURL}
                                    roundedCircle
                                    width={36}
                                    height={36}
                                    alt={user.displayName ?? user.email ?? 'Usuario'}
                                />
                            )}
                            <span className="text-light">
                                {user.displayName ?? user.email ?? 'Usuario sin nombre'}
                            </span>
                            <Button
                                variant="warning"
                                onClick={logout}
                                disabled={loading}
                            >
                                Cerrar sesión
                            </Button>
                        </>
                    ) : (
                        <span className="text-light">
                            Ingresa con tu correo usando el formulario inferior.
                        </span>
                    )}
                </div>
            </Navbar>
        </>
    );
};
